import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Container, Grid, Icon, Message } from 'semantic-ui-react'
import { AiOutlineInbox } from 'react-icons/ai'
import { useEditHandleError } from '../../Common/Hooks/useEditHandleError'
import { loadSerieById, newSerie, saveSerie, updateState } from '../Slice/SerieSlice'
import SerieForm from '../Form/SerieForm'
import './css/SerieListPage.css'

export default function SerieEditPage () {
  const { t } = useTranslation()
  const {
    isLoading,
    isSuccess,
    isError,
    message
  } = useSelector((state) => state.serie)
  const dispatch = useDispatch()
  const { serieId } = useParams()
  const [errorList, goBack, handleError] = useEditHandleError('/serie')

  useEffect(() => {
    if (serieId === 'new') {
      dispatch(newSerie())
    } else {
      dispatch(loadSerieById(serieId))
    }
  }, [])

  useEffect(() => {
    handleError(isSuccess, isError, message)
    dispatch(updateState())
  }, [isSuccess, isError, message])

  const onSaveSerie = () => {
    dispatch(saveSerie())
  }

  return (
    <Container className='serie-list-page'>
      <div className='serie-title serie-division'>
        <Grid columns={2}>
          <Grid.Column>
            <Icon size='large'><AiOutlineInbox /></Icon>
            {
              serieId === 'new'
                ? (<span>{ t('serie.new') }</span>)
                : (<>
                  <span>{ t('serie.edit') }</span>
                  <small className='mx-3'># { serieId }</small>
                </>)
            }
          </Grid.Column>
          <Grid.Column textAlign='right'>
            <Button
              icon
              labelPosition='left'
              color='grey'
              size='large'
              disabled={isLoading}
              onClick={goBack}>
              <Icon name='arrow circle left' /> { t('generic.goBack') }
            </Button>
            <Button
              icon
              labelPosition='left'
              color='green'
              size='large'
              disabled={isLoading}
              onClick={onSaveSerie}>
              <Icon name='save' /> { t('generic.save') }
            </Button>
          </Grid.Column>
        </Grid>
      </div>
      <div className="p-4">
        <SerieForm />
      </div>
      <div className="p-4">
        { errorList.length > 0 &&
          <Message error icon='exclamation triangle'
                   header={ t('generic.validation.onSave') }
                   list={errorList} />
        }
      </div>
    </Container>
  )
}
